import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { MiniGame } from 'src/domains/casino/webview/CasinoGames/mini-games/mini-games-grid/grid-body/mini-game/MiniGame';
import { GridBodyWrapper } from 'src/domains/casino/webview/CasinoGames/mini-games/mini-games-grid/grid-body/GridBody.style';
import { AppCasinoState } from 'src/domains/casino/state/AppCasino.state';
import { ShowMoreButton } from 'src/domains/casino/webview/CasinoGames/mini-games/mini-games-grid/grid-footer/ShowMoreButton';
import { useCommon } from 'src/domains/common/Common';
import { BreakpointsState } from 'src/domains/layouts/state/breakpointsState/BreakpointsState';

interface GridBodyPropsType {
    appCasinoState: AppCasinoState;
}

export const GridBody = observer('GridBody', (props: GridBodyPropsType) => {
    const { appCasinoState } = props;

    const common = useCommon();
    const breakPointState = BreakpointsState.get(common);
    const isDesktop = breakPointState.desktop.isBiggerOrEq === true;

    const { miniGamesListState } = appCasinoState;
    const { toggleExtendGamesList, isGamesListExtended, miniGamesToDisplay } = miniGamesListState;

    return (
        <>
            <GridBodyWrapper>
                {miniGamesToDisplay.map((game) => (
                    <MiniGame
                        appCasinoState={appCasinoState}
                        key={game.id}
                        gameId={game.id}
                    />
                ))}
            </GridBodyWrapper>

            {isDesktop ? (
                <ShowMoreButton
                    isGamesListExtended={isGamesListExtended}
                    toggleExtendGamesList={toggleExtendGamesList}
                    dataTest='mini-games-see-more-button'
                />
            ) : null}
        </>
    );
});
